import { render, staticRenderFns } from "./BadgeCancelamento.vue?vue&type=template&id=32ccbe7d&scoped=true"
import script from "./BadgeCancelamento.vue?vue&type=script&lang=ts"
export * from "./BadgeCancelamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ccbe7d",
  null
  
)

export default component.exports